import { CampaignId } from 'modules/campaigns/types/campaign-interface'

export const getCampaignUrl = (id: CampaignId) => `/campaigns/${id}`
